import { APP, RUN_APP } from '@common/loan-act/env'

export const logo = (() => {
  const imgSource = {
    [APP.ssj]: 'https://operation.feidee.com/ope/loan-wechat/logo-ssj.png',
    [APP.kn]: 'https://operation.feidee.com/ope/loan-wechat/loog-kn.png',
  }
  return imgSource[RUN_APP]
})()

export default logo
